import { render, staticRenderFns } from "./DialogLeave.vue?vue&type=template&id=53fdf9d3"
import script from "./DialogLeave.vue?vue&type=script&lang=js"
export * from "./DialogLeave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports